import './RecentGames.css';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '../../../../hooks/use-translations.hook';
import { SearchGameItem } from '../SearchGameItem';

export const RecentGames = () => {
    const { t } = useTranslations();
    const { isLoggedIn, recentGames } = useSelector((state) => (state.player));
    const { gamesById } = useSelector((state) => (state.casino));
    const [gamesToShow, setGamesToShow] = useState([]);

    useEffect(() => {
        if (Array.isArray(recentGames) && recentGames.length > 0) {
            setGamesToShow(recentGames.slice(0, 3));
        }
    }, [recentGames]);

    if (!isLoggedIn || gamesToShow.length === 0) {
        return null;
    }

    return (
        <div className="asg-search-results-recent">
            <div className="asg-search-results-recent__title asg-search-results-title">{t('playAgain')}</div>
            <div className="asg-search-results-recent__list">
                {gamesToShow.map((gameId) => (<SearchGameItem
                    key={gameId}
                    game={gamesById[gameId]}
                />))}
            </div>
        </div>
    );
};
